import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2dda692"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cmp footer" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"items\" data-v-d2dda692><div class=\"title\" data-v-d2dda692>Contact</div><div class=\"text\" data-v-d2dda692>9/36 rue Chanzy</div><div class=\"text\" data-v-d2dda692>59350 Saint-André-Lez-Lille, FR</div><div class=\"text\" data-v-d2dda692>hello@wildsys.io</div></div>", 1)
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column not mobile" }, null, -1))
const _hoisted_8 = { class: "column" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo not mobile" }, null, -1))
const _hoisted_10 = { class: "items" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Services", -1))
const _hoisted_12 = { class: "column" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo not mobile" }, null, -1))
const _hoisted_14 = { class: "items" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Entreprise", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://wildsys.cloud",
  target: "_blank",
  class: "link"
}, " WildSys Cloud ", -1))

import LogoSVG from '@/components/design/LogoSVG.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(LogoSVG, { fill: "#caccd2" })
          ]),
          _hoisted_6
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_router_link, {
              class: "link",
              to: "/#ctoaas"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" CTO as a Service ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "link",
              to: "/#develop"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Développement ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "link",
              to: "/#hosting"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Hébergement ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_router_link, {
              class: "link",
              to: "/company/legals"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Mentions légales ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "link",
              to: "/contact"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Nous contacter ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "link",
              to: "/company/jobs"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Recrutement ")
              ]),
              _: 1
            }),
            _hoisted_16
          ])
        ])
      ])
    ])
  ]))
}
}

})